import React, { useContext } from 'react';
import Tabs from './Tabs';
import SearchBar from './SearchBar';
import FilterButton from './FilterButton';
import TopItemsSelector from './TopItemsSelector';
import SettingsButton from './SettingsButton';
import AppliedFilters from './AppliedFilters';
import CategoryRelevancyTable from './CategoryRelevancyTable';
import { CategoryRelevancyContext } from '../contexts/CategoryRelevancyContext';
import { useMenuControl } from '../hooks/useMenuControl';
import { CATEGORY_RELEVANCY } from '../constants/CategoryRelevancyConstants';

const CategoryRelevancy: React.FC = () => {
    const {
        activeTab,
        masterCategories,
        masterCategoryTypes,
        rowDensity,
        openMenu,

        rawCategories,
        rawCategoryTypes,
        rawExpandedCategories,
        rawCoSoldCategories,
        rawFilters,
        rawSearchTerm,
        rawSortBy,
        rawSortOrder,
        rawLoadingCategories,
        isRawCoSoldCategoryLoading: isRawCategoryLoading,
        handleRawCategoryExpand,
        handleRawSearch,
        handleRawFilterChange,
        handleRawRemoveFilter,
        handleRawSort,

        curatedCategories,
        curatedExpandedCategories,
        curatedCoSoldCategories,
        curatedFilters,
        curatedSearchTerm,
        curatedSortBy,
        curatedSortOrder,
        curatedLoadingCategories,
        isCuratedCoSoldCategoryLoading: isCuratedCategoryLoading,
        handleCuratedCategoryExpand,
        handleCuratedSearch,
        handleCuratedFilterChange,
        handleCuratedRemoveFilter,
        handleCuratedSort,

        setActiveTab,
        handleToggleCuration,
        handleTopItemsChange,
        handleRowDensityChange,

        topItems,
        customTopItems
    } = useContext(CategoryRelevancyContext);

    const { toggleMenu, filterRef, topItemsRef, settingsRef } = useMenuControl();

    const currentCategories = activeTab === 'raw' ? rawCategories : curatedCategories;
    const currentExpandedCategories = activeTab === 'raw' ? rawExpandedCategories : curatedExpandedCategories;
    const currentCoSoldCategories = activeTab === 'raw' ? rawCoSoldCategories : curatedCoSoldCategories;
    const currentFilters = activeTab === 'raw' ? rawFilters : curatedFilters;
    const currentSearchTerm = activeTab === 'raw' ? rawSearchTerm : curatedSearchTerm;
    const currentSortBy = activeTab === 'raw' ? rawSortBy : curatedSortBy;
    const currentSortOrder = activeTab === 'raw' ? rawSortOrder : curatedSortOrder;
    const currentLoadingCategories = activeTab === 'raw'
        ? rawLoadingCategories : curatedLoadingCategories
    const currentLoadingCoSoldCategories = activeTab === 'raw'
        ? isRawCategoryLoading : isCuratedCategoryLoading
    const handleCategoryExpand = activeTab === 'raw' ? handleRawCategoryExpand : handleCuratedCategoryExpand;
    const handleSearch = activeTab === 'raw' ? handleRawSearch : handleCuratedSearch;
    const handleFilterChange = activeTab === 'raw' ? handleRawFilterChange : handleCuratedFilterChange;
    const handleRemoveFilter = activeTab === 'raw' ? handleRawRemoveFilter : handleCuratedRemoveFilter;
    const handleSort = activeTab === 'raw' ? handleRawSort : handleCuratedSort;

    return (
        <section aria-labelledby="category-relevancy-title">
            <h1
                id="category-relevancy-title"
                className="tw-justify-start tw-text-black tw-font-semibold tw-text-xl tw-mt-6 tw-mb-4"
            >
                {CATEGORY_RELEVANCY}
            </h1>

            <div className="tw-mt-2 tw-box-border tw-w-auto tw-border-t-[1px] tw-border-solid tw-border-lightgray-200" />

            <div className="tw-mb-6">
                <Tabs activeTab={activeTab} onTabChange={setActiveTab} />
            </div>

            <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-mb-4 tw-gap-y-3">
                <SearchBar value={currentSearchTerm} onChange={handleSearch} />

                <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
                    <div ref={filterRef}>
                        <FilterButton
                            filters={currentFilters}
                            onFilterChange={handleFilterChange}
                            categories={masterCategories}
                            categoryTypes={masterCategoryTypes}
                            isOpen={openMenu === 'filter'}
                            onToggle={() => toggleMenu('filter')}
                            activeTab={activeTab}
                        />
                    </div>

                    {activeTab === 'raw' && <div ref={topItemsRef}>
                        <TopItemsSelector
                            value={topItems}
                            customValue={customTopItems}
                            onChange={handleTopItemsChange}
                            disabled={false}
                            isOpen={openMenu === 'topItems'}
                            onToggle={() => toggleMenu('topItems')}
                        />
                    </div>}

                    <div ref={settingsRef}>
                        <SettingsButton
                            onRowDensityChange={handleRowDensityChange}
                            isOpen={openMenu === 'settings'}
                            onToggle={() => toggleMenu('settings')}
                            currentDensity={rowDensity}
                        />
                    </div>
                </div>
            </div>

            <AppliedFilters
                filters={currentFilters}
                onRemoveFilter={handleRemoveFilter}
                onFilterChange={handleFilterChange}
            />

            <CategoryRelevancyTable
                categories={currentCategories}
                expandedCategories={currentExpandedCategories}
                coSoldCategories={currentCoSoldCategories}
                onCategoryExpand={handleCategoryExpand}
                onToggleCuration={handleToggleCuration}
                isCuratedTab={activeTab === 'curated'}
                rowDensity={rowDensity}
                loadingCategories={currentLoadingCategories}
                loadingCoSoldCategories={currentLoadingCoSoldCategories}
                handleSort={handleSort}
                sortBy={currentSortBy}
                sortOrder={currentSortOrder}
            />
        </section>
    );
};

export default CategoryRelevancy;